import { Box } from "@mui/material";
import {
  MSearchByArea,
  MSearchByGenre,
  MSearchByScene,
  MSearchByCondition,
  FooterSection,
} from "../sections";
import { MobileFilter } from "features/searchStore/components/MobileFilter";
import { MHeaderSection } from "components/MHeaderSection";

export function MobileView() {
  return (
    <Box display="flex" width="100%" flexDirection="column" bgcolor="#faf8f5">
      <MHeaderSection />
      <Box m={1} borderRadius={2} boxShadow={2} bgcolor="#af9b65" px={1.5}>
        <MobileFilter />
      </Box>

      <MSearchByArea />

      <MSearchByGenre />

      <MSearchByScene />

      <MSearchByCondition />
      <FooterSection />
    </Box>
  );
}
